module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_6-847eb3ae193ef6624a359a76b93f4349.png";